<script lang="ts">
  import type { Snippet } from "svelte"
  import { newNotification } from "@kontextwerk/web-sdk/core/overlay/notifications"
  import StepActionCTA from "../../../../../../../../../../../../_shared/_modules/step-action-cta"
  import type {
    CompleteLoadListIntent,
    CompleteLoadListResult,
  } from "../../actions/completeLoadList"

  type Props = {
    children?: Snippet<[Snippet]>
    intent: CompleteLoadListIntent
    onSubmissionResult: (result: CompleteLoadListResult) => Promise<void> | void
  }

  const { children = null, intent, onSubmissionResult }: Props = $props()

  let pending = $state(false)

  const run = async () => {
    if (pending) return

    if (intent.kind === "blocked") {
      newNotification({ class: "error", html: intent.message })

      return
    }

    pending = true
    try {
      await onSubmissionResult(
        intent.kind === "continue"
          ? { kind: "continued" }
          : { kind: "completed", output: intent.output },
      )
    } catch (error) {
      console.error("batch_load_list_completion_failed", error)
      newNotification({
        class: "error",
        html: "Der Schritt konnte nicht abgeschlossen werden. Bitte erneut versuchen.",
      })
    } finally {
      pending = false
    }
  }
</script>

{#snippet primaryAction()}
  <StepActionCTA
    type="primaryButton"
    content={pending ? "Aufträge werden gespeichert…" : intent.label}
    onClick={run}
    disabled={pending || intent.disabled}
    disabledReason={pending ? "Der Schritt wird gerade abgeschlossen." : intent.disabledReason}
  />
{/snippet}

{#if children}
  {@render children(primaryAction)}
{:else}
  {@render primaryAction()}
{/if}
